<template>
  <div>
    <v-row align="center" justify="start">
      <v-col cols="12" sm="6" md="4" lg="3">
        <UsersDropDownList
          :clearable="true"
          :userId="selectedUserIdValue"
          @userIdChange="handleUserIdChange"
          @userNameChange="handleUserNameChange"
        ></UsersDropDownList>
      </v-col>
      <v-col cols="12" sm="6" md="3" lg="2">
        <SecurityRolesDropDownList
          :clearable="true"
          :securityRoles="securityRoles"
          @securityRolesChange="handleSecurityRolesChange"
        ></SecurityRolesDropDownList>
      </v-col>
      <v-col cols="12" sm="6" md="3" lg="2">
        <v-switch
          class="my-auto"
          v-model="includeInactive"
          label="Include Inactive"
        ></v-switch>
      </v-col>
    </v-row>
    <v-row justify="end">
      <v-col cols="12" sm="6">
        <FilterButtons
          @search="handleSearchClick"
          @clear="handleClearClick"
        ></FilterButtons>
      </v-col>
    </v-row>
    <FilterButtonsSmall
      @search="handleSearchClick"
      @clear="handleClearClick"
    ></FilterButtonsSmall>
  </div>
</template>

<script>
import { mapFields } from '@/vueHelpers/vuex'
import { mapActions } from 'vuex'
import { FilterButtons, FilterButtonsSmall } from '@/components/buttons'
import { SecurityRolesDropDownList } from '@/components/securityRoles'
import UsersDropDownList from '@/components/users/UsersDropDownList'

export default {
  props: {
    selectedUserId: {
      type: Number,
      default: null
    }
  },
  components: {
    FilterButtons,
    FilterButtonsSmall,
    SecurityRolesDropDownList,
    UsersDropDownList
  },
  computed: {
    ...mapFields('userFilters', [
      'firstName',
      'lastName',
      'securityRoles',
      'active'
    ]),
    selectedUserIdValue: {
      get () {
        return this.selectedUserId
      },
      set (newValue) {
        this.$emit('selectedUserIdChange', newValue)
      }
    },
    includeInactive: {
      get () {
        return this.active !== true
      },
      set (newValue) {
        this.active = newValue ? null : true
        this.handleSearchClick()
      }
    }
  },
  methods: {
    ...mapActions('userFilters', [
      'clearFilters'
    ]),
    handleSearchClick () {
      this.$emit('search')
    },
    handleUserNameChange (firstName, lastName) {
      this.firstName = firstName
      this.lastName = lastName
    },
    handleUserIdChange (newValue) {
      this.selectedUserIdValue = newValue
    },
    handleSecurityRolesChange (newValue) {
      this.securityRoles = newValue
    },
    handleClearClick () {
      this.selectedUserIdValue = null
      this.clearFilters()
      this.$emit('clear')
    }
  }
}
</script>
<style>
  .text-small {
    font-size:10px !important;
  }
</style>
